import React from 'react'
import NewListingPage from 'containers/NewListingPage'
import { getMessage } from 'lib/translator'
import OfferTableProperties from './OfferTableProperties'
import emptyIcon from 'icons/no-orders.svg'

function OffersListing({ selectedOfferIds, history }) {
  // Create a unique key based on selectedOfferIds to force re-render when selection changes
  const listingKey = Array.isArray(selectedOfferIds)
    ? selectedOfferIds.join(',')
    : String(selectedOfferIds)

  return (
    <div>
      <NewListingPage
        key={listingKey}
        className="pin-wallet-details-table"
        api={{
          url: `/offer-service/offer`,
          params: {
            id: selectedOfferIds,
            includeCount: false,
            page: 1,
          },
          transform: (response) => response.data.offers,
        }}
        emptyState={{
          icon: emptyIcon,
          message: getMessage('offer.offerIdsConfig.emptyOffers'),
        }}
        primaryKey="id"
        tableProperties={OfferTableProperties(history)}
        tableDynamic
      />
    </div>
  )
}

export default OffersListing
